import { EventEmitter, Input ,Output} from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-log-history',
  templateUrl: './view-log-history.component.html',
  styleUrls: ['./view-log-history.component.scss']
})
export class ViewLogHistoryComponent implements OnInit {
  @Input() viewLogHeaderName: string;
  @Input() labelName: string;
  @Input() viewLogArray: any[];
  @Output() onCancel = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  public cancel(): void{
    this.onCancel.emit();
  }
}

